module.exports = __webpack_public_path__ + "media/old_images/default-avatar-f2f35f70.png";